import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Button from '../../widgets/Button';
import { useWidgetsModalContext } from '../../../shared/providers/WidgetsModalProvider';
import {
  addItemToSessionStorage,
  getItemFromSessionStorage,
} from '../../../utilities/common/storage';
import { StorageItems } from '../../../shared/constants/app';
import feedbackVisual from '../../../assets/icons/Feedback/feedback-visual.svg';
import CloseIcon from '../../../assets/icons/General/close.svg?react';
import { EventActions, EventNames } from '../../../shared/constants/analytics';

import useTracking from '../../../utilities/hooks/useTracking';

interface IFeedbackBannerProps {
  loading: boolean;
}

function FeedbackBanner({ loading }: IFeedbackBannerProps) {
  const { setFeedbackPopupOpen, setFeedbackWidget } = useWidgetsModalContext();
  const { t } = useTranslation();
  const { slug } = useParams();
  const { trackEvent } = useTracking();

  const path = slug!.replace(/[\s-]/g, '_').toLowerCase();

  const feedbackBanner = getItemFromSessionStorage(
    StorageItems.FEEDBACK_MODAL_CLOSE,
    'string',
  );

  function handleClose() {
    setFeedbackWidget(false);
    addItemToSessionStorage(StorageItems.FEEDBACK_MODAL_CLOSE, 'true');
  }

  return loading == undefined ? (
    <div className=" h-[120px] animate-pulse rounded-lg bg-black-200"></div>
  ) : (
    <div
      className={`  ${
        !feedbackBanner
          ? 'relative items-center  overflow-hidden rounded-xl border border-black-200 bg-white pr-6 shadow-[0px_1px_2px_0px_#1018280D] md:flex '
          : 'hidden'
      }`}
    >
      <Button
        variant="ghost"
        type="button"
        className={` absolute right-3 top-3 inline-flex items-center rounded-lg  `}
        onClick={handleClose}
      >
        <CloseIcon className="w-[13.18px] stroke-black-500" />
        <span className="sr-only">Close this modal</span>
      </Button>
      <img src={feedbackVisual} className=" mr-6 w-full max-w-[253px]" alt="" />{' '}
      <div className="w-full items-center justify-between  px-6 py-6 md:px-0 xl:flex">
        <div className="mb-4 xl:mb-0  ">
          <h3 className=" pb-1 text-lg font-semibold text-black-900">
            {t('FEEDBACK_BANNER_HEADING')}
          </h3>
          <span className=" block max-w-[548px] text-black-600">
            {t('FEEDBACK_BANNER_SUBHEADING')}
          </span>
        </div>

        <Button
          className="relative min-w-[147px] 2xl:right-10"
          onClick={() => {
            setFeedbackPopupOpen(true);
            trackEvent(EventNames.WellBeingDashboard, {
              eventLabel: 'get_feedback',
              eventCategory: 'get_feedback',
              eventAction: EventActions.click,
              eventValue: path,
              eventSource: path,
            });
          }}
        >
          {t('SUBMIT_FEEDBACK')}
        </Button>
      </div>
    </div>
  );
}

export default FeedbackBanner;
